<template>
 <div class="padded">



   <el-row :gutter="12">
     <el-col :xs="24" :sm="12" :md="8">
       <table class="el-table">
         <tr>
           <td>Date:</td><td><strong>{{formatDate(rowData.date)}}</strong></td>
         </tr>
         <tr>
           <td>Invoice #:</td>
           <td>
             <el-row>
               <el-col :span="15">
                <strong>{{rowData.invoiceNo}}</strong><span v-if="isDesktop">&nbsp;{{rowData.invoiceType}}</span>
               </el-col>
               <el-col :span="9">
                 <download-button
                    :url="'print/invoice/'+ rowData.id + '/excel'"
                    icon="fa fa-file-excel"
                    size="mini"
                    type="primary">Excel</download-button>
               </el-col>
              </el-row>
           </td>

         </tr>
         <tr>
           <td>Term:</td><td><strong>{{rowData.terms}}</strong> days</td>
         </tr>
       </table>
     </el-col>


     <el-col :xs="24" :sm="12" :md="8">
       <table class="el-table">
         <tr>
           <td>To:</td><td><strong>{{rowData.to.name}}</strong></td>
         </tr>
         <tr>
           <td>Line Items:</td>
           <td>
             <el-row>
               <el-col :span="15">
                <strong>{{rowData.lines}}</strong>
               </el-col>
               <el-col :span="9">
                 <download-button
                   :url="'print/invoice/'+ rowData.id"
                   icon="fa fa-file-pdf"
                   size="mini"
                   type="danger">Print</download-button>
               </el-col>
              </el-row>
           </td>
         </tr>
         <tr>
           <td>From:</td><td><strong>{{rowData.from.name}}</strong></td>
         </tr>
       </table>
     </el-col>


     <el-col :xs="24" :sm="12" :md="8">
       <table class="el-table">
         <tr>
           <td>Total</td><td><strong class="text-primary">{{this.formatNumber(rowData.total)}}</strong></td>
         </tr>
         <tr>
           <td>Paid</td>
           <td>
             <el-row>
               <el-col :span="14">
                 <strong class="text-success">{{this.formatNumber(rowData.totalPaid)}}</strong>&nbsp;
               </el-col>
               <el-col :span="10">
                 <invoice-payment :row-data="rowData" button-type="round" />
               </el-col>
              </el-row>
            </td>
         </tr>
         <tr>
           <td>O/S</td><td><strong class="text-warning">{{this.formatNumber(rowData.total - rowData.totalPaid)}}</strong></td>
         </tr>
       </table>

     </el-col>
   </el-row>


   <data-table
     title="Invoice Items"
     table-ref="lineItems"
     :url="'invoice/' + rowData.id + '/items'"
     :fields="fields"
     sort-field="id"
     :add-props="{items: checked}"
     :add-action="payAll"
     :checked-callback="itemsChecked"
     detail-component="item-payment-detail-row" >

      <template #odue="props">
        <el-row style="width: 10rem;">
          <el-col align="left" :span="isSuper() ? 17 : 24" :offset="1">
            <!-- eslint-disable-next-line vue/no-v-html -- formatter output, numeric → coloured span markup -->
            <span v-html="formatDue(props.rowData.totalPaid, props.rowData.total)"></span>
          </el-col>
          <el-col v-if="isSuper()" align="right" :span="2" :offset="4">
            <el-button type="danger" v-if="!props.rowData.paid"
             @click="deleteLine(props.rowData.id, props.rowData.details)"
             size="mini" icon="fa fa-trash-alt" />
          </el-col>
        </el-row>
      </template>

   </data-table>

  </div>
</template>


<script>

import Vue from 'vue'

import {settings} from '@/components/Data'

import PostMixins from '@/mixins/PostMixins'
import DateMixins from '@/mixins/DateMixins'
import NumberMixins from '@/mixins/NumberMixins'

import DownloadButton from '@/components/atoms/files/DownloadButton'

import InvoicePayment from '@/components/finance/payment/InvoicePayment'
import ItemPaymentDetail from '@/components/finance/payment/ItemPaymentDetail'
import PayAllButton from '@/components/finance/payment/PayAllButton'

Vue.component('item-payment-detail-row', ItemPaymentDetail)

export default {
  name: 'InvoiceDetails',
  mixins: [PostMixins, DateMixins, NumberMixins],

  components: {
    DownloadButton,
    InvoicePayment,
    PayAllButton
  },

  props: {
    rowData: {
      type: Object,
      required: true
    }
  },

  methods: {
/*
    downloaded () {
      this.$message({
        type: 'success',
        title: 'Invoice Download',
        message: 'Invoice downloaded OK'
      })
    },

    downloadPdf (invId, invNo) {
      if (invId) {
        this.downloadFile('/print/invoice/' + invId, this.downladed, invNo)
      }
    },
*/
    itemsChecked (state, selected) {
      this.checked = selected
    },

    deleted () {
      console.log('Deleted OK')
    },

    deleteLine (id, details) {
      this.deleteItem(this, id, '/invoice/item/', 'Line Item: ' + details, this.deleted)
    },

    formatTotal: function (value) {
      return '<strong>' + this.formatNumber(value) + '</strong>'
    },

    formatDue: function (value, total) {

      if (!value || value <= 0.00) {
        return ''
      }

      var text = ''
      var color = '#878D99'

      if (value === total) {
        text = '<i class="fa fa-ok"></i>'
        color = 'seagreen'
      }

      if (value > 0 && value > total) {
        text = '<i class="fa fa-chevron-up"></i> ' + this.formatNumber(total - value).trim()
        color = 'indianred'
      }

      if (value > 0 && value < total) {
        text = '<i class="fa fa-chevron-down"></i> ' + this.formatNumber(total - value).trim()
        color = 'goldenrod'
      }

      return '<strong style="color: ' + color + ';">' + text.trim() + '</strong>'
    }

  },

  data () {
    return {
      checked: [],
      payAll: PayAllButton,
      taxLabel: settings.taxName,
      fields: [
        {
          name: '__sequence',
          title: '#',
          sortField: 'id'
        },
        {
          name: '__checkbox',
          title: '',
          titleClass: 'hidden-sm-and-down',
          dataClass: 'hidden-sm-and-down'
        },
        {
          name: 'detailRef',
          title: 'Ref',
          sortField: 'detailRef',
          titleClass: 'hidden-sm-and-down',
          dataClass: 'hidden-sm-and-down'
        },
        {
          name: 'details',
          title: 'Details',
          sortField: 'details'
        },
        {
          name: 'quantity',
          title: 'Qty',
          sortField: 'quantity'
        },
        {
          name: 'subtotal',
          title: 'Sub-Total',
          sortField: 'subtotal',
          callback: this.formatNumber,
          titleClass: 'hidden-md-and-down',
          dataClass: 'hidden-md-and-down'
        },
        {
          name: 'tax',
          title: this.taxLabel,
          sortField: 'tax',
          callback: this.formatNumber,
          titleClass: 'hidden-md-and-down',
          dataClass: 'hidden-md-and-down'
        },
        {
          name: 'total',
          title: 'TOTAL',
          sortField: 'total',
          callback: this.formatTotal
        },
        {
          name: '__slot:odue',
          title: 'Paid',
          titleClass: 'hidden-sm-and-down',
          dataClass: 'hidden-sm-and-down'
        }
      ]
    }
  }

}

</script>

<style scoped>
.local-table {width: 100%;}
.local-table .local-table td, .local-table th {background: white;}
.local-table th {border-bottom: 1pt solid lightgray;}
</style>
